import { LitElement, html } from 'lit-element';
import { ScopedElementsMixin } from '@open-wc/scoped-elements';
import AabIcon from '@aab/sc-aab-icon/src/AabIcon';
import {
  sy_notification_error as iconError, sy_notification_error_outlined as iconErrorOutlined,
  sy_notification_inactive as iconInactive, sy_notification_inactive_outlined as iconInactiveOutlined,
  sy_notification_info as iconInfo, sy_notification_info_outlined as iconInfoOutlined,
  sy_notification_verified as iconVerified, sy_notification_verified_outlined as iconVerifiedOutlined,
  sy_notification_warning as iconWarning, sy_notification_warning_outlined as iconWarningOutlined,
} from '@aab/sc-aab-icon-set';
import Styles from './styles';

export default class AabInputMessage extends ScopedElementsMixin(LitElement) {
  static get properties() {
    return {
      message: { type: String },
      type: { type: String },
      testId: { type: String },
      icon: { type: Boolean },
      iconOutlined: {
        type: Boolean,
        attribute: 'icon-outlined',
      },
      large: { type: Boolean },
      background: { type: Boolean },
      textNowrap: {
        type: Boolean,
        attribute: 'text-nowrap',
      },
    };
  }

  static get styles() {
    return Styles;
  }

  constructor() {
    super();
    this.testId = 'aab_inputmessage';
    this.message = '';
    this.type = 'info';
    this.textNowrap = false;
  }

  static get scopedElements() {
    return {
      'aab-icon': AabIcon,
    };
  }

  static getIcon(type, icon) {
    switch (type) {
      case 'inactive': return icon ? iconInactive : iconInactiveOutlined;
      case 'negative': return icon ? iconError : iconErrorOutlined;
      case 'positive': return icon ? iconVerified : iconVerifiedOutlined;
      case 'warning': return icon ? iconWarning : iconWarningOutlined;
      default: return icon ? iconInfo : iconInfoOutlined;
    }
  }

  render() {
    const icon = AabInputMessage.getIcon(this.type, this.icon);
    return html`
      <div
        class="d-flex"
        id="${this.testId}"
        ?hidden=${this.message === ''}>
        ${this.icon || this.iconOutlined ? html`
          <div class="px-0 inline-icon ${this.background ? 'background' : ''} ${this.type}">
            <aab-icon svg=${icon} size="2"></aab-icon>
          </div>
        ` : ''}
        <div class="${this.icon || this.iconOutlined || this.background ? 'spx-1' : ''} 
        text-area ${this.background ? 'background' : ''} ${this.type}">
        
          <div class="px-0">
            <span class="message-text ${this.type} ${this.large ? '' : 'text-small'} ${this.textNowrap ? 'text-nowrap' : ''}">${this.message}</span>
          </div>
        </div>

      </div>
    `;
  }
}
